import type { InAppMessageExpiration } from "@hightouch/lib/cep/inapp-messages/expiry";
import pluralize from "pluralize";

import { EditorType } from "src/cep/messages/types";
import type { JourneyMessageConfig } from "src/pages/journeys/types";

/**
 * The in-app instance held in the tile's editor state, its one copy of the
 * content. Null for a tile whose buffer has none, such as one never edited.
 */
export function inAppContentFromMessageConfig(
  messageConfig: JourneyMessageConfig | null | undefined,
): { templateId: string; values: unknown } | null {
  const editorState = messageConfig?.editor_state;
  if (
    editorState?.editorType === EditorType.InApp &&
    editorState.editorState.templateId
  ) {
    return {
      templateId: editorState.editorState.templateId,
      values: editorState.editorState.values,
    };
  }
  return null;
}

export function describeInAppExpiration(
  expiration: InAppMessageExpiration | undefined,
): string {
  if (!expiration || !(expiration.quantity > 0)) return "Not set";
  return `${expiration.quantity} ${pluralize(expiration.unit, expiration.quantity)}`;
}
